<template>
  <YapButtonIcon :aria-label="state.isDarkTheme ? 'Light theme' : 'Dark theme'" @click="toggleTheme">
    <span v-if="!state.isDarkTheme">
      <YapIcon name="moon-outline" />
    </span>
    <span v-else>
      <YapIcon name="sun-outline" />
    </span>
  </YapButtonIcon>
</template>

<script setup lang="ts">
import { reactive } from 'vue';
import YapIcon from '@/components/YapIcon.vue';
import YapButtonIcon from '@/components/YapButtonIcon.vue';
import { useProfileStore } from '@/store/profileStore';
import { Theme } from '@/types/general';

const profileStore = useProfileStore();

const state = reactive({
  isDarkTheme:
    localStorage.theme === Theme.DARK_THEME ||
    (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)
});

const toggleTheme = () => {
  if (
    localStorage.theme === Theme.DARK_THEME ||
    (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)
  ) {
    localStorage.theme = Theme.LIGHT_THEME;
    document.documentElement.classList.remove(Theme.DARK_THEME);
    profileStore.setTheme(Theme.LIGHT_THEME);
    state.isDarkTheme = false;
  } else {
    localStorage.theme = Theme.DARK_THEME;
    document.documentElement.classList.add(Theme.DARK_THEME);
    profileStore.setTheme(Theme.DARK_THEME);
    state.isDarkTheme = true;
  }
};
</script>
